module.exports = __webpack_public_path__ + "img/Content3.72b16b7a.png";